import React from "react";
import './mainmessage.css'
import {
    Row,
    Col,
    Container,
    Image,
    Button
} from "react-bootstrap";
import picture from '../../../images/placeholder.jpg'
// import SearchLocationInput from '../search-location-api/search-location-api'
import NewLocationSearch from '../search-location-api/new-location-search'
import { LinkContainer } from 'react-router-bootstrap'

export default function MainMessage() {
    return (
        <div id='blue' >
            <LinkContainer to="/register">
            <Button
                id="custom-button-container"
                className=" my-5 float-right p-2 m-0"
                variant="primary"
                onClick={() => console.log('hello')}
            >
                Join Today
            </Button>
            </LinkContainer>
            <Container fluid="xl">
                <Row xs={1} md={2} lg={2} >
                    <Col className="my-5" >
                        <h1>Find a dentist close to you.</h1>
                        <h5>Find a new dentist that perfectly matches your needs, is nearby, and ready to deliver a great experience.</h5>
                        {/* <Form inline>
                            <FormControl type="text" placeholder="Enter your address" />
                        <Button variant="outline-success">Search</Button>
                        </Form> */}
                        <NewLocationSearch/>
                    </Col>
                    <Col className="my-5" >
                        <Image src={picture} fluid rounded  ></Image>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}